import IconBanSolid from '@/assets/icons/font_awesome/ban-solid.svg?react';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { UI_PRIMITIVE__tooltip } from '@/components/ui/UI_PRIMITIVE__tooltip';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { remote_workspace_user_update_permissions } from '@/state/workspace/user/remote_workspace_user_update_permissions';
import { DTO__workspace_user } from '@shared/dto/+workspace/workspace_user/DTO__workspace_user';

interface Props {
  user: DTO__workspace_user;
}

export function WSButtonFeaturesDenyAllUser({ user }: Props) {
  const dispatch = use_dispatch();

  async function onClick() {
    user = user.clone({ permissions: [] });

    await dispatch(remote_workspace_user_update_permissions(user));
  }

  return (
    <UI_PRIMITIVE__tooltip tooltip_title="Deny all features">
      <UI_PRIMITIVE__button_with_icon_animated
        variant={'no-border-on-component'}
        renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
        Icon={IconBanSolid}
        onClick={onClick}
        disabled={user.permissions.length === 0}
        className="w-5 h-5 !p-0"
        iconClassNameBase="!w-5 !h-5"
        iconClassNameHovered={` !text-red-400`}
        iconClassNameNonHovered={` !text-red-700`}
      />
    </UI_PRIMITIVE__tooltip>
  );
}
